/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Channel_DirectInputs */

const vi_order_channel_direct = /** @type {(inputs: Order_Channel_DirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tại cửa hàng`)
};

/**

* @param {Order_Channel_DirectInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_channel_direct = /** @type {((inputs?: Order_Channel_DirectInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Channel_DirectInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_channel_direct(inputs)
});